module.exports = __webpack_public_path__ + "img/area-5-3.71ac454.jpg";